import { render, staticRenderFns } from "./OrderPDItemEdit.vue?vue&type=template&id=8f84cce0"
import script from "./OrderPDItemEdit.vue?vue&type=script&lang=js"
export * from "./OrderPDItemEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderPDItemEdit.vue?vue&type=style&index=0&id=8f84cce0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports